<template>
  <div class="clock" :class="clockStyle">
    <div :class="timeStyle">{{ _hours }}</div>
    :
    <div :class="timeStyle">{{ _minutes }}</div>
    :
    <div :class="timeStyle">{{ _seconds }}</div>
  </div>
</template>

<script>
export default {
  props: ["size"],
  data() {
    return {
      hours: "00",
      minutes: "00",
      seconds: "00",
      countDownDate: new Date(),
      countDownDone: false,
    };
  },
  computed: {
    _hours() {
      return this.hours;
    },
    _minutes() {
      return this.minutes;
    },
    _seconds() {
      return this.seconds;
    },
    clockStyle() {
      return {
        "clock--small": this.isSmall(),
        "clock--big": this.isBig(),
      };
    },
    timeStyle() {
      return {
        time: true,
        "time--small": this.isSmall(),
        "time--big": this.isBig(),
      };
    },
  },
  methods: {
    tick() {
      if (!this.countDownDone) {
        // Update the count down every 1 second
        // Get today's date and time
        var now = new Date().getTime();

        // Find the distance between now and the count down date
        var distance = this.countDownDate - now;

        // Time calculations for days, hours, minutes and second
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);

        if (minutes < 10) {
          this.minutes = "0" + minutes;
        } else {
          this.minutes = minutes;
        }

        if (seconds < 10) {
          this.seconds = "0" + seconds;
        } else {
          this.seconds = seconds;
        }

        // If the count down is finished, write some text
        if (distance < 0) {
          alert("Done");
          this.countDownDone = true;
        }
      }
    },
    isSmall() {
      if (this.size === "small") {
        return true;
      }
    },
    isBig() {
      if (this.size === "big") {
        return true;
      }
    },
  },
  mounted() {
    setInterval(() => this.tick(), 1000);
    this.countDownDate.setHours(this.countDownDate.getHours() + 1);
  },
};
</script>

<style lang="scss" scoped>
@import "../../sass/_variables.scss";
@import "../../sass/_mixins.scss";

.clock {
  font-size: 5rem;
  color: $color-secondary;
  padding-top: 5rem;
  padding-left: 1rem;

  &--small {
    position: absolute;
    top: 2rem;
    left: 0;
    z-index: 1;
    font-size: 2rem;
  }

  &--big {
    font-size: 10rem;

    @include respond(break1) {
      font-size: 9rem;
    }

    @include respond(break3) {
      font-size: 7rem;
    }
  }
}

.time {
  display: inline-block;
  padding: 2rem;
  background-image: radial-gradient(
    rgba($color-primary-dark, 0.8),
    rgba($color-primary-light, 0.8)
  );
  border-radius: 50%;
  box-shadow: rgb(38, 57, 77) 0rem 1rem 4rem -1.5rem;
  text-align: center;

  &--small {
    width: 7rem;
  }

  &--big {
    width: 20rem;

    @include respond(break1) {
      width: 20rem;
    }

    @include respond(break3) {
      width: 17rem;
    }
  }
}
</style>
